import { useDispatch, useSelector } from 'react-redux';
import { selectShowDialog2, setShowDialog2 } from '../state/slices';
import { CONTACT_LINK_WHATSAPP, CONTACT_LINK_WHATSAPP_DUBAI, CONTACT_PHONE, CONTACT_PHONE_DUBAI, CONTACT_PHONE_LINK, CONTACT_PHONE_LINK_DUBAI } from '../constants';
import { useState } from 'react';
import StaticPool from '../state/static_pool';

function CustomDialog() {
  
  const dispatch = useDispatch();
  const showDialog2 = useSelector(selectShowDialog2);

  if (!showDialog2) return null;

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  };

  const dialogStyle = {
    backgroundColor: 'white',
    padding: '25px 0px 0px 0px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    position: 'relative',
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    backgroundColor: '#e0e0e0', // light grey
    border: 'none',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    width: '22px',
    height: '22px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: '1',
    padding: '0',
  };


  return (
    <div onClick={() => { 
        dispatch(setShowDialog2(false));
        document.body.style.overflow = '';
      }} style={overlayStyle}>
      <div style={dialogStyle}>
        <button
          style={closeButtonStyle}
          onClick={() => { 
            dispatch(setShowDialog2(false));
            document.body.style.overflow = '';
          }}
          aria-label="Close dialog"
        >
          ×
        </button>
        <Title text={StaticPool.actionType === 'phone'? "Call Now": "WhatsApp Now"} />
        <div style={{ height: '20px' }}></div>
        <NumberTile country={"India"} phone={CONTACT_PHONE} onClick={()=> { 
            dispatch(setShowDialog2(false));
            document.body.style.overflow = '';
            if (StaticPool.actionType === 'phone') {
                window.location.href = CONTACT_PHONE_LINK;
            }
            if (StaticPool.actionType === 'whatsapp') {
                // window.location.href = CONTACT_LINK_WHATSAPP;
                window.open(CONTACT_LINK_WHATSAPP, '_blank', 'noopener,noreferrer');
            }
        }} />
        <NumberTile country={"Dubai"} phone={CONTACT_PHONE_DUBAI} onClick={()=> { 
            dispatch(setShowDialog2(false)); 
            document.body.style.overflow = '';
            if (StaticPool.actionType === 'phone') {
                window.location.href = CONTACT_PHONE_LINK_DUBAI;
            }
            if (StaticPool.actionType === 'whatsapp') {
                // window.location.href = CONTACT_LINK_WHATSAPP_DUBAI;
                window.open(CONTACT_LINK_WHATSAPP_DUBAI, '_blank', 'noopener,noreferrer');
            }
        }} />
      </div>
    </div>
  );
}

function Title({ text }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      fontWeight: 'bold',
      fontSize: '16px'
    }}>
      <div>{text}</div>
    </div>
  );
}

function NumberTile({ country, phone, onClick }) {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: isHovered ? '#f0f0f0' : 'transparent',
        padding: '18px 25px',
        borderRadius: '8px',
        cursor: 'pointer',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <div>{country}</div>
      <div style={{ width: '50px' }}></div>
      <div>{phone}</div>
    </div>
  );
}

export default CustomDialog;
